import React, { useState, useEffect } from "react";

import "./ProgressiveHintingDemo.css";

const PROBLEM = "Solve: 2x + 4 = 10";
const HINTS = [
    "Try to isolate the term that contains x.",
    "Subtract 4 from both sides → 2x = 6.",
    "Now divide both sides by 2.",
    "x = 3 ✓",
];

const REVEAL_INTERVAL_MS = 1600;
const RESET_PAUSE_MS = 2400;

const ProgressiveHintingDemo = () => {
    const [revealed, setRevealed] = useState(0);

    useEffect(() => {
        const isFinished = revealed >= HINTS.length;
        const delay = isFinished ? RESET_PAUSE_MS : REVEAL_INTERVAL_MS;

        const timeout = setTimeout(() => {
            setRevealed((n) => (n >= HINTS.length ? 0 : n + 1));
        }, delay);

        return () => clearTimeout(timeout);
    }, [revealed]);

    const buttonActive = revealed < HINTS.length;

    return (
        <div className="progressive-hint-demo" aria-hidden="true">
            <div className="hint-header">
                <span className="hint-label">Problem</span>
                <button
                    type="button"
                    tabIndex={-1}
                    className={"hint-btn" + (buttonActive ? " is-active" : "")}
                >
                    💡 Hint
                </button>
            </div>
            <div className="hint-problem">{PROBLEM}</div>
            <div className="hint-body">
                {HINTS.map((h, i) => {
                    const visible = i < revealed;
                    const isLatest = i === revealed - 1;
                    return (
                        <div
                            key={i}
                            className={
                                "hint-bubble" +
                                (visible ? " is-visible" : "") +
                                (isLatest ? " is-latest" : "")
                            }
                        >
                            <span className="hint-bubble-index">Hint {i + 1}</span>
                            <span className="hint-bubble-text">{h}</span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ProgressiveHintingDemo;
